import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 }).format(amount || 0);
};

const ProjectModal = ({ formData, setFormData, onSubmit, onClose, isEdit }) => (
  <div className="modal-overlay" onClick={onClose}>
    <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '700px', maxHeight: '85vh', overflowY: 'auto' }}>
      <div className="modal-header">
        <h3 className="modal-title">{isEdit ? 'Edit Project' : 'Create New Project'}</h3>
        <button className="modal-close" onClick={onClose}>×</button>
      </div>
      <form onSubmit={onSubmit}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
          <div className="form-group">
            <label className="form-label">Project Name *</label>
            <input type="text" required className="form-input" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} />
          </div>
          <div className="form-group">
            <label className="form-label">Developer Name</label>
            <input type="text" className="form-input" value={formData.developer_name} onChange={(e) => setFormData({ ...formData, developer_name: e.target.value })} />
          </div>
          <div className="form-group">
            <label className="form-label">Location</label>
            <input type="text" className="form-input" value={formData.location} onChange={(e) => setFormData({ ...formData, location: e.target.value })} />
          </div>
          <div className="form-group">
            <label className="form-label">Sub Location</label>
            <input type="text" className="form-input" value={formData.sub_location} onChange={(e) => setFormData({ ...formData, sub_location: e.target.value })} />
          </div>
          <div className="form-group">
            <label className="form-label">RERA Number</label>
            <input type="text" className="form-input" value={formData.rera_number} onChange={(e) => setFormData({ ...formData, rera_number: e.target.value })} />
          </div>
          <div className="form-group">
            <label className="form-label">Towers</label>
            <input type="number" className="form-input" value={formData.number_of_towers} onChange={(e) => setFormData({ ...formData, number_of_towers: e.target.value })} />
          </div>
          <div className="form-group">
            <label className="form-label">Levels / Floors</label>
            <input type="number" className="form-input" value={formData.levels} onChange={(e) => setFormData({ ...formData, levels: e.target.value })} />
          </div>
          <div className="form-group">
            <label className="form-label">Total Units</label>
            <input type="number" className="form-input" value={formData.total_units} onChange={(e) => setFormData({ ...formData, total_units: e.target.value })} />
          </div>
          <div className="form-group">
            <label className="form-label">Stamp Duty (%)</label>
            <input type="number" step="0.1" className="form-input" value={formData.stamp_duty_rate} onChange={(e) => setFormData({ ...formData, stamp_duty_rate: e.target.value })} />
          </div>
          <div className="form-group">
            <label className="form-label">GST (%)</label>
            <input type="number" step="0.1" className="form-input" value={formData.gst_rate} onChange={(e) => setFormData({ ...formData, gst_rate: e.target.value })} />
          </div>
          <div className="form-group">
            <label className="form-label">Registration (%)</label>
            <input type="number" step="0.1" className="form-input" value={formData.registration_charge_rate} onChange={(e) => setFormData({ ...formData, registration_charge_rate: e.target.value })} />
          </div>
          <div className="form-group">
            <label className="form-label">Floor Rise (₹/floor)</label>
            <input type="number" className="form-input" value={formData.floor_rise_rate} onChange={(e) => setFormData({ ...formData, floor_rise_rate: e.target.value })} />
          </div>
          <div className="form-group">
            <label className="form-label">Proposed Possession</label>
            <input type="date" className="form-input" value={formData.proposed_possession_date || ''} onChange={(e) => setFormData({ ...formData, proposed_possession_date: e.target.value })} />
          </div>
          <div className="form-group">
            <label className="form-label">RERA Date</label>
            <input type="date" className="form-input" value={formData.rera_date || ''} onChange={(e) => setFormData({ ...formData, rera_date: e.target.value })} />
          </div>
          <div className="form-group">
            <label className="form-label">Status</label>
            <select className="form-input" value={formData.status} onChange={(e) => setFormData({ ...formData, status: e.target.value })}>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
              <option value="completed">Completed</option>
            </select>
          </div>
        </div>
        <div className="form-group" style={{ marginTop: '12px' }}>
          <label className="form-label">Notes</label>
          <textarea className="form-input" rows="3" value={formData.notes || ''} onChange={(e) => setFormData({ ...formData, notes: e.target.value })} />
        </div>
        <div style={{ display: 'flex', gap: '12px', marginTop: '16px' }}>
          <button type="submit" className="btn btn-primary" style={{ flex: 1 }}>{isEdit ? 'Update Project' : 'Create Project'}</button>
          <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
        </div>
      </form>
    </div>
  </div>
);

const Projects = ({ apiBase }) => {
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [towers, setTowers] = useState([]);
  const [typologies, setTypologies] = useState([]);
  const [costSheetItems, setCostSheetItems] = useState([]);
  const [inventoryStats, setInventoryStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [formData, setFormData] = useState({
    name: '', developer_name: '', location: '', sub_location: '',
    rera_number: '', number_of_towers: 0, levels: 0,
    proposed_possession_date: '', rera_date: '',
    stamp_duty_rate: 6.0, gst_rate: 5.0, registration_charge_rate: 1.0,
    floor_rise_rate: 200, total_units: 0, price_per_unit: 0,
    status: 'active', notes: ''
  });

  useEffect(() => { fetchProjects(); }, []);

  const handleDelete = async (id, name) => {
    if (!window.confirm(`Delete project "${name}"? This cannot be undone.`)) return;
    try {
      await axios.delete(`${apiBase}/projects/${id}`);
      fetchProjects();
    } catch (e) { alert('Error: ' + (e.response?.data?.error || e.message)); }
  };

  const fetchProjects = async () => {
    try {
      const res = await axios.get(`${apiBase}/projects`);
      setProjects(res.data);
    } catch (err) {
      console.error('Error fetching projects:', err);
    } finally {
      setLoading(false);
    }
  };

  const fetchProjectDetails = useCallback(async (project) => {
    setSelectedProject(project);
    try {
      const masterRes = await axios.get(`${apiBase}/projects/${project.id}/master`);
      const master = masterRes.data;
      setTowers(master.towers || []);
      setTypologies(master.typologies || []);
      setCostSheetItems(master.costSheetItems || []);
      setInventoryStats(master.statusSummary || null);
      // Merge master data back into selectedProject
      setSelectedProject(prev => ({ ...prev, ...master.project }));
    } catch (err) {
      console.error('Error fetching master data:', err);
      // Fallback - fetch towers/typologies individually
      try { const t = await axios.get(`${apiBase}/towers?project_id=${project.id}`); setTowers(t.data); } catch(e){}
      try { const ty = await axios.get(`${apiBase}/typologies?project_id=${project.id}`); setTypologies(ty.data); } catch(e){}
    }
  }, [apiBase]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        ...formData,
        number_of_towers: parseInt(formData.number_of_towers) || 0,
        levels: parseInt(formData.levels) || 0,
        total_units: parseInt(formData.total_units) || 0,
        stamp_duty_rate: parseFloat(formData.stamp_duty_rate) || 6.0,
        gst_rate: parseFloat(formData.gst_rate) || 5.0,
        registration_charge_rate: parseFloat(formData.registration_charge_rate) || 1.0,
        floor_rise_rate: parseFloat(formData.floor_rise_rate) || 200
      };
      if (isEdit && selectedProject) {
        await axios.put(`${apiBase}/projects/${selectedProject.id}`, payload);
        await fetchProjects();
        // Refresh the detail view
        const updated = (await axios.get(`${apiBase}/projects`)).data.find(p => p.id === selectedProject.id);
        if (updated) fetchProjectDetails(updated);
      } else {
        await axios.post(`${apiBase}/projects`, payload);
        fetchProjects();
      }
      setShowModal(false);
    } catch (err) {
      alert('Error saving: ' + (err.response?.data?.error || err.message));
    }
  };

  const handleRERAUpload = async (e) => {
    const file = e.target.files[0];
    if (!file || !selectedProject) return;
    const fd = new FormData();
    fd.append('certificate', file);
    try {
      await axios.post(`${apiBase}/projects/${selectedProject.id}/rera-certificate`, fd);
      alert('RERA Certificate uploaded');
      fetchProjects();
    } catch (err) {
      alert('Error uploading: ' + (err.response?.data?.error || err.message));
    }
  };

  if (loading) return <div className="loading">Loading projects...</div>;

  // PROJECT LIST VIEW
  if (!selectedProject) {
    return (
      <div>
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Projects</h2>
            <button className="btn btn-primary" onClick={() => { setIsEdit(false); setFormData({ name: '', developer_name: '', location: '', sub_location: '', rera_number: '', number_of_towers: 0, levels: 0, proposed_possession_date: '', rera_date: '', stamp_duty_rate: 6.0, gst_rate: 5.0, registration_charge_rate: 1.0, floor_rise_rate: 200, total_units: 0, price_per_unit: 0, status: 'active', notes: '' }); setShowModal(true); }}>+ New Project</button>
          </div>
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>Project Name</th>
                  <th>Developer</th>
                  <th>Location</th>
                  <th>RERA</th>
                  <th>Towers</th>
                  <th>Units</th>
                  <th>Price PSF</th>
                  <th>Possession</th>
                  <th>Status</th>
                <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {projects.map((project) => (
                  <tr key={project.id} onClick={() => fetchProjectDetails(project)} style={{ cursor: 'pointer' }}>
                    <td><strong>{project.name}</strong></td>
                    <td>{project.developer_name || '-'}</td>
                    <td>{project.location} {project.sub_location ? `- ${project.sub_location}` : ''}</td>
                    <td style={{ fontSize: '12px', fontFamily: 'monospace' }}>{project.rera_number || '-'}</td>
                    <td>{project.number_of_towers || 0}</td>
                    <td>{project.total_units || 0}</td>
                    <td style={{ fontWeight: 600, color: '#16a34a' }}>₹{formatCurrency(project.price_per_sqft || project.base_rate_per_sqft || 0)}</td>
                    <td>
                      <span className={`badge ${project.possession_status === 'Ready to Move' ? 'badge-success' : 'badge-warning'}`}>
                        {project.possession_status || 'Under Construction'}
                      </span>
                    </td>
                    <td><span className={`badge badge-${project.status === 'active' ? 'success' : 'secondary'}`}>{project.status}</span></td>
                    <td><button onClick={(e) => { e.stopPropagation(); handleDelete(project.id, project.name); }} style={{ padding: "3px 8px", borderRadius: "6px", border: "1px solid #fca5a5", background: "#fef2f2", color: "#dc2626", cursor: "pointer", fontSize: "11px" }} title="Delete Project">🗑️</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        {showModal && <ProjectModal formData={formData} setFormData={setFormData} onSubmit={handleSubmit} onClose={() => setShowModal(false)} isEdit={false} />}
      </div>
    );
  }

  // PROJECT DETAIL VIEW
  const p = selectedProject;
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <div>
          <button className="btn btn-secondary" onClick={() => setSelectedProject(null)} style={{ marginBottom: '12px' }}>← Back to Projects</button>
          <h1 style={{ margin: 0 }}>{p.name}</h1>
          <p style={{ color: '#64748b', marginTop: '4px' }}>{p.location} {p.sub_location ? `- ${p.sub_location}` : ''} {p.address ? `| ${p.address}` : ''}</p>
        </div>
        <button className="btn btn-primary" onClick={() => {
          setIsEdit(true);
          setFormData({
            name: p.name, developer_name: p.developer_name, location: p.location,
            sub_location: p.sub_location, rera_number: p.rera_number,
            number_of_towers: p.number_of_towers, levels: p.levels,
            proposed_possession_date: p.proposed_possession_date ? p.proposed_possession_date.split('T')[0] : '',
            rera_date: p.rera_date ? p.rera_date.split('T')[0] : '',
            stamp_duty_rate: p.stamp_duty_rate || 6.0, gst_rate: p.gst_rate || 5.0,
            registration_charge_rate: p.registration_charge_rate || 1.0,
            floor_rise_rate: p.floor_rise_rate || 200, total_units: p.total_units,
            price_per_unit: p.price_per_unit, status: p.status, notes: p.notes
          });
          setShowModal(true);
        }}>Edit Project</button>
      </div>

      {/* Overview Cards */}
      <div className="card" style={{ marginBottom: '24px' }}>
        <h2 className="card-title">Project Overview</h2>
        <div className="stats-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))' }}>
          <div className="stat-card">
            <div className="stat-label">RERA Number</div>
            <div className="stat-value" style={{ fontSize: '14px' }}>{p.rera_number || 'Not Set'}</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">Towers</div>
            <div className="stat-value">{p.number_of_towers || 0}</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">Floors</div>
            <div className="stat-value">{p.levels || 0}</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">Total Units</div>
            <div className="stat-value">{p.total_units || 0}</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">Price PSF</div>
            <div className="stat-value" style={{ fontSize: '16px', color: '#16a34a' }}>₹{formatCurrency(p.price_per_sqft || p.base_rate_per_sqft)}</div>
          </div>
          <div className="stat-card">
            <div className="stat-label">Possession</div>
            <div className="stat-value" style={{ fontSize: '14px', color: p.possession_status === 'Ready to Move' ? '#16a34a' : '#d97706' }}>{p.possession_status || 'Under Construction'}</div>
          </div>
        </div>

        {/* Pricing */}
        <div style={{ marginTop: '24px', padding: '16px', background: '#f0fdf4', borderRadius: '8px', border: '1px solid #bbf7d0' }}>
          <h3 style={{ marginBottom: '12px', fontSize: '16px', color: '#166534' }}>💰 Pricing</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '12px' }}>
            <div>
              <div style={{ fontSize: '12px', color: '#64748b' }}>Price per Sq.Ft</div>
              <div style={{ fontSize: '18px', fontWeight: '700', color: '#166534' }}>₹{formatCurrency(p.price_per_sqft || p.base_rate_per_sqft)}</div>
            </div>
            <div>
              <div style={{ fontSize: '12px', color: '#64748b' }}>Floor Rise / Floor</div>
              <div style={{ fontSize: '16px', fontWeight: '600' }}>₹{formatCurrency(p.floor_rise_rate)}</div>
            </div>
            <div>
              <div style={{ fontSize: '12px', color: '#64748b' }}>Carpet Area Range</div>
              <div style={{ fontSize: '14px', fontWeight: '600' }}>{p.carpet_area_range || '-'}</div>
            </div>
            <div>
              <div style={{ fontSize: '12px', color: '#64748b' }}>Price Range</div>
              <div style={{ fontSize: '14px', fontWeight: '600' }}>{p.price_range || '-'}</div>
            </div>
            <div>
              <div style={{ fontSize: '12px', color: '#64748b' }}>Min Price</div>
              <div style={{ fontSize: '14px', fontWeight: '600' }}>₹{formatCurrency(p.min_price)}</div>
            </div>
            <div>
              <div style={{ fontSize: '12px', color: '#64748b' }}>Max Price</div>
              <div style={{ fontSize: '14px', fontWeight: '600' }}>₹{formatCurrency(p.max_price)}</div>
            </div>
          </div>
        </div>

        {/* Taxes */}
        <div style={{ marginTop: '16px', padding: '16px', background: '#eff6ff', borderRadius: '8px', border: '1px solid #bfdbfe' }}>
          <h3 style={{ marginBottom: '12px', fontSize: '16px', color: '#1e40af' }}>🧾 Taxes & Statutory Charges</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '12px' }}>
            <div>
              <div style={{ fontSize: '12px', color: '#64748b' }}>Stamp Duty</div>
              <div style={{ fontSize: '16px', fontWeight: '600' }}>{p.stamp_duty_rate || 6.0}%</div>
            </div>
            <div>
              <div style={{ fontSize: '12px', color: '#64748b' }}>GST</div>
              <div style={{ fontSize: '16px', fontWeight: '600' }}>{p.gst_rate || 5.0}%</div>
            </div>
            <div>
              <div style={{ fontSize: '12px', color: '#64748b' }}>Registration (%)</div>
              <div style={{ fontSize: '16px', fontWeight: '600' }}>{p.registration_charge_rate || 1.0}%</div>
            </div>
            <div>
              <div style={{ fontSize: '12px', color: '#64748b' }}>Registration (Flat)</div>
              <div style={{ fontSize: '16px', fontWeight: '600' }}>₹{formatCurrency(p.registration_flat_amount || 30000)}</div>
            </div>
          </div>
        </div>

        {/* Other Charges */}
        <div style={{ marginTop: '16px', padding: '16px', background: '#fefce8', borderRadius: '8px', border: '1px solid #fde68a' }}>
          <h3 style={{ marginBottom: '12px', fontSize: '16px', color: '#854d0e' }}>📦 Other Charges</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '12px' }}>
            {[
              { label: 'Legal Charges', value: p.legal_charges },
              { label: 'Car Parking', value: p.car_parking_charge },
              { label: 'Maintenance Deposit', value: p.maintenance_deposit, suffix: '/sqft' },
              { label: 'Corpus Fund', value: p.corpus_fund },
              { label: 'Infra Charges', value: p.infra_charges },
              { label: 'Advance Maintenance', value: p.advance_maintenance },
            ].map((item, i) => (
              <div key={i}>
                <div style={{ fontSize: '12px', color: '#64748b' }}>{item.label}</div>
                <div style={{ fontSize: '16px', fontWeight: '600' }}>₹{formatCurrency(item.value)}{item.suffix || ''}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Project Details */}
        <div style={{ marginTop: '16px', padding: '16px', background: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
          <h3 style={{ marginBottom: '12px', fontSize: '16px', color: '#334155' }}>🏛️ Project Details</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px' }}>
            <div><div style={{ fontSize: '12px', color: '#64748b' }}>Address</div><div style={{ fontSize: '14px', fontWeight: '500' }}>{p.address || '-'}</div></div>
            <div><div style={{ fontSize: '12px', color: '#64748b' }}>Pincode</div><div style={{ fontSize: '14px', fontWeight: '500' }}>{p.pincode || '-'}</div></div>
            <div><div style={{ fontSize: '12px', color: '#64748b' }}>Contact Email</div><div style={{ fontSize: '14px', fontWeight: '500' }}>{p.contact_email || '-'}</div></div>
            <div><div style={{ fontSize: '12px', color: '#64748b' }}>Contact Phone</div><div style={{ fontSize: '14px', fontWeight: '500' }}>{p.contact_phone || '-'}</div></div>
            <div><div style={{ fontSize: '12px', color: '#64748b' }}>Website</div><div style={{ fontSize: '14px' }}>{p.website_url ? <a href={p.website_url} target="_blank" rel="noopener noreferrer" style={{ color: '#2563eb' }}>{p.website_url}</a> : '-'}</div></div>
            <div><div style={{ fontSize: '12px', color: '#64748b' }}>RERA Date</div><div style={{ fontSize: '14px', fontWeight: '500' }}>{p.rera_date ? new Date(p.rera_date).toLocaleDateString() : 'Not Set'}</div></div>
          </div>
        </div>

        {/* RERA Certificate */}
        <div style={{ marginTop: '16px' }}>
          {p.rera_certificate_url && (
            <a href={`${apiBase.replace('/api', '')}${p.rera_certificate_url}`} target="_blank" rel="noopener noreferrer" className="btn btn-secondary" style={{ textDecoration: 'none', marginRight: '12px' }}>📄 View RERA Certificate</a>
          )}
          <div style={{ marginTop: '8px' }}>
            <label className="form-label">Upload RERA Certificate</label>
            <input type="file" accept=".pdf,.jpg,.jpeg,.png" onChange={handleRERAUpload} className="form-input" />
          </div>
        </div>
      </div>

      {/* Towers */}
      <div className="card" style={{ marginBottom: '24px' }}>
        <h2 className="card-title">🏢 Towers & Wings ({towers.length})</h2>
        {towers.length > 0 ? (
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>Tower/Wing</th>
                  <th>Building</th>
                  <th>Floors</th>
                  <th>Units/Floor</th>
                  <th>Total Units</th>
                  <th>BHK Types</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {towers.map((t) => (
                  <tr key={t.id}>
                    <td><strong>{t.tower_name}</strong></td>
                    <td>{t.building || '-'}</td>
                    <td>{t.number_of_floors || t.total_floors || '-'}</td>
                    <td>{t.units_per_floor || '-'}</td>
                    <td style={{ fontWeight: 600 }}>{t.total_units || '-'}</td>
                    <td style={{ fontSize: '12px' }}>{t.bhk_types || '-'}</td>
                    <td><span className={`badge badge-${t.status === 'active' ? 'success' : 'secondary'}`}>{t.status}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : <p style={{ color: '#94a3b8', textAlign: 'center', padding: '20px' }}>No towers configured.</p>}
      </div>

      {/* Typologies */}
      <div className="card" style={{ marginBottom: '24px' }}>
        <h2 className="card-title">📐 Configurations ({typologies.length})</h2>
        {typologies.length > 0 ? (
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>BHK Type</th>
                  <th>Carpet Area</th>
                  <th>Super Area</th>
                  <th>Price PSF</th>
                  <th>Base Price</th>
                </tr>
              </thead>
              <tbody>
                {typologies.map((t) => (
                  <tr key={t.id}>
                    <td><strong>{t.bhk_type}</strong></td>
                    <td>{t.carpet_area ? `${t.carpet_area} sq.ft` : '-'}</td>
                    <td>{t.super_area ? `${t.super_area} sq.ft` : '-'}</td>
                    <td>₹{formatCurrency(t.price_per_sqft)}</td>
                    <td style={{ fontWeight: 600 }}>₹{formatCurrency(t.base_price)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : <p style={{ color: '#94a3b8', textAlign: 'center', padding: '20px' }}>No typologies configured.</p>}
      </div>

      {/* Cost Sheet Config */}
      {costSheetItems.length > 0 && (
        <div className="card" style={{ marginBottom: '24px' }}>
          <h2 className="card-title">🧾 Cost Sheet Config ({costSheetItems.length} items)</h2>
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>Component</th>
                  <th>Type</th>
                  <th>Rate</th>
                  <th>%?</th>
                  <th>Mandatory</th>
                </tr>
              </thead>
              <tbody>
                {costSheetItems.map((item, i) => (
                  <tr key={i}>
                    <td style={{ fontWeight: 500 }}>{item.component_name}</td>
                    <td><span className="badge badge-info">{item.component_type}</span></td>
                    <td style={{ fontWeight: 600 }}>{item.is_percentage ? `${item.rate}%` : `₹${formatCurrency(item.rate)}`}</td>
                    <td>{item.is_percentage ? '✅' : '—'}</td>
                    <td>{item.is_mandatory ? '✅' : '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Inventory Status */}
      {inventoryStats && Object.keys(inventoryStats).length > 0 && (
        <div className="card">
          <h2 className="card-title">📦 Inventory Status</h2>
          <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
            {Object.entries(inventoryStats).map(([status, count]) => (
              <div key={status} style={{ padding: '16px 24px', borderRadius: '10px', textAlign: 'center', background: status === 'Open For Sale' ? '#d1fae5' : status === 'Booked' ? '#fce7f3' : '#f1f5f9', minWidth: '120px' }}>
                <div style={{ fontSize: '28px', fontWeight: '800' }}>{count}</div>
                <div style={{ fontSize: '12px', fontWeight: '600', color: '#64748b' }}>{status}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {showModal && <ProjectModal formData={formData} setFormData={setFormData} onSubmit={handleSubmit} onClose={() => setShowModal(false)} isEdit={isEdit} />}
    </div>
  );
};

export default Projects;
